module.exports = __webpack_public_path__ + "static/img/avatar.07f9692b.png";